import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Models } from '../../models/global.models';
import { LoanOfficerNotesLeadStore } from './loan-officer-notes-lead.store';

@Injectable({ providedIn: 'root' })
export class LoanOfficerNotesLeadQuery extends Query<Models.LoanOfficerNotesLeadForm> {
  protected store: LoanOfficerNotesLeadStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(LoanOfficerNotesLeadStore);

    super(store);

    this.store = store;
  }
}
